import * as React from 'react';
import { browserInfo } from './browser_info';
import { map } from 'lodash';

interface IProps {
  inputPrefix?: string;
}

export default class BrowserInfoHiddenFields extends React.Component<IProps, null> {
  static defaultProps: IProps = {
    inputPrefix: 'browser_info',
  };

  renderBrowserInfo() {
    return map(browserInfo(), (value, key) => {
      return (
        <input
          type="hidden"
          name={`${this.props.inputPrefix}[${key}]`}
          key={`${this.props.inputPrefix}-${key}`}
          value={value as string}
        />
      );
    });
  }

  render() {
    return (
      <div>
        {this.renderBrowserInfo()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/browser_info_hidden_fields.tsx